import { getDocumentos, createDocumento, updateDocumento, deleteDocumento, getImpuestoDocumento } from '../models/documentoModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchDocumentos(page, perPage) {
  try {
    const response = await getDocumentos(page, perPage);
    return {
      documento: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching documentos:", error);
    Swal.fire('Error', 'No se pudieron cargar los documentos', 'error');
    return null;
  }
}

export async function saveDocumento(documento, currentDocumentoId) {
  let documentoId;

  try {
    if (currentDocumentoId) {
      await updateDocumento(currentDocumentoId, documento);
      documentoId = currentDocumentoId;

      toasts.add({
        title: 'Éxito',
        description: 'Documento guardado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      const newDocumento = await createDocumento(documento);
      documentoId = newDocumento.id;

      toasts.add({
        title: 'Éxito',
        description: 'Documento creado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving documento:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el documento',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }

  // Llamar a saveImpuestosDocumento después de guardar el documento
  if (documento['impuestos'] && documento['impuestos'].length > 0) {
    console.log('documento:', documento);
    await saveImpuestosDocumento(documentoId, documento['impuestos']);
  }
}

export async function removeDocumento(id) {
  try {
    await deleteDocumento(id);
    toasts.add({
      title: 'Éxito',
      description: 'Documento eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting documento:", error);
    Swal.fire('Error', 'No se pudo eliminar el documento', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'documento'
export function subscribeToDocumentos(searchQuery, handleSearch) {
  pb.collection('documento').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromDocumentos() {
  pb.collection('documento').unsubscribe('*');
}

export async function searchDocumentos(query, page = 1, perPage = 10) {
  const response = await pb.collection('documento').getList(page, perPage, {
    filter: `descrip ~ "${query}" || tipo ~ "${query}"`,
  });
  return {
    documento: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

export async function fetchImpuestoDocumento(id) {
  try {
    // Make the API call to fetch impuestos related to documento
    const response = await getImpuestoDocumento(id);
    
    return {
      impuestos: response,
    };
  } catch (error) {
    console.error("Error fetching impuestos documento:", error);
    // SweetAlert2 error message
    Swal.fire('Error', 'No se pudieron cargar los impuestos del documento', 'error');
    return null;
  }
}


export async function saveImpuestosDocumento(documentoId, impuestos) {
  // Elimina los impuestos existentes antes de guardar los nuevos
  await deleteImpuestosDocumento(documentoId);
  
  try {
    // Itera sobre cada impuesto y guarda/actualiza en la colección 'impuesto_documento'
    for (const { impuesto } of impuestos) {
      await pb.collection('impuesto_documento').create({
        documento: documentoId,
        impuesto: impuesto.id,
        tasa: impuesto.tasa,
        porc: impuesto.porc,
      });
    }

    toasts.add({
      title: 'Éxito',
      description: 'Impuestos actualizados exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error('Error guardando impuestos:', error);
    toasts.add({
      title: 'Error',
      description: 'No se pudieron guardar los impuestos',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}


export async function deleteImpuestosDocumento(documentoId) {
  try {
    // Recupera los impuestos del documento
    const response = await pb.collection('impuesto_documento').getList(1, 50, {
      filter: `documento="${documentoId}"`,
    });

    // Elimina cada impuesto individualmente
    const deletePromises = response.items.map((item) =>
      pb.collection('impuesto_documento').delete(item.id)
    );

    await Promise.all(deletePromises);
    console.log('Impuestos eliminados correctamente');
  } catch (error) {
    console.error('Error eliminando impuestos del documento:', error);
    throw new Error('No se pudieron eliminar los impuestos');
  }
}